import React, { useState, useEffect, useRef } from 'react';
import { API } from '../../../API/API';
import { DataGrid } from 'devextreme-react';
import { Column, Export, Item, SearchPanel, Selection, Toolbar, Lookup, LoadPanel, TotalItem, Summary } from 'devextreme-react/data-grid';
import { Lookup as FieldLookup, DropDownOptions } from 'devextreme-react/lookup';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { constData } from '../../../const/Const';

const TT11Sheet1 = (props) => {

    const gridRef = useRef();
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [defaultData, setDefault] = useState({});
    const [nondirecttypes] = useState(constData.nondirecttypes);

    const getData = async (year, quarter) => {
        let tData = [];
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        if (!quarter)
            quarter = Math.floor(month / 3) + 1;
        if (!year)
            year = dateObj.getUTCFullYear();

        setDefault({ key: year + '.' + quarter, text: year + ' /' + quarter + ' -р улирал/' });
        await API.get('/api/payroll/report/getsheet1?year=' + year + '&quarter=' + quarter).then(response => {
            if (response.status == 200 && response.data.retType == 0) {
                tData = response.data.retData;
            }
        });
        setData(tData);
    }

    const getFilterData = async (year, quarter) => {
        let tData = [];
        await API.get('/api/payroll/report/getsheetfilter').then(response => {
            if (response.status == 200 && response.data.retType == 0) {
                tData = response.data.retData;
            }
        });
        setFilterData(tData);
    }

    useEffect(() => {
        getFilterData();
        getData();
    }, []);

    const filterOnChange = async (e) => {
        if (e?.value) {
            getData(e?.value.split('.')[0], e?.value.split('.')[1]);
        }
    }

    const calcTax71 = (ssiincome, empssi, taxincome, emptax) => {
        return emptax * ((ssiincome - empssi) / taxincome);
    }

    const calcTax71AfterDiscount = (ssiincome, empssi, taxincome, emptax, taxdiscount) => {
        var a = emptax * ((ssiincome - empssi) / taxincome) - taxdiscount;
        return a < 0 ? 0 : a;
    }

    const calcTax716 = (contractssiincome, contractempssi, taxincome, emptax) => {
        return emptax * ((contractssiincome - contractempssi) / taxincome);
    }

    const calcTaxNonDirect = (ssiincome, empssi, contractssiincome, contractempssi, taxincome, emptax) => {
        return emptax - emptax * ((contractssiincome - contractempssi) / taxincome) - emptax * ((ssiincome - empssi) / taxincome);
    }

    return (
        <div style={{ height: 'calc(100vh - 150px)', width: '100%' }}>
            <PageHeader
                title='Цалин, хөдөлмөрийн хөлс, шагнал, урамшуулал болон тэдгээртэй адилтгах хөдөлмөр эрхлэлтийн орлогод ногдуулан суутгасан албан татварын мэдээ /XM_11(1)/' />
            <div style={{ padding: 16 }}>
                <DataGrid
                    ref={gridRef}
                    dataSource={data}
                    showBorders={true}
                    columnAutoWidth={true}
                    hoverStateEnabled={true}
                    wordWrapEnabled={false}>
                    <SearchPanel visible={true} highlightCaseSensitive={true} />
                    <Export enabled={true} />
                    <LoadPanel enabled />
                    <Toolbar>
                        <Item location="before">
                            <FieldLookup onValueChanged={filterOnChange}
                                displayExpr="text"
                                width={250}
                                wrapItemText={true}
                                valueExpr="key"
                                searchEnabled={false}
                                showCancelButton={false}
                                value={defaultData.key}
                                items={filterData} >
                                <DropDownOptions
                                    hideOnOutsideClick={true}
                                    showTitle={false}
                                />
                            </FieldLookup>
                        </Item>

                        <Item
                            name="searchPanel"
                        />
                        <Item
                            name="exportButton"
                        />
                    </Toolbar>
                    <Selection
                        mode="single"
                    />
                    <Column dataField="civilid" caption="Татвар төлөгчийн дугаар" fixed={true} fixedPosition="left" width={120} />
                    <Column dataField="lastname" caption="Овог" width={140} />
                    <Column dataField="firstname" caption="Нэр" width={140} />
                    <Column caption="Татвар ногдох орлого">
                        <Column dataField="ssiincome" caption="Хуулийн 7.1.1" width={120} format=",###,###,##0.00" />
                        <Column dataField="additional" caption="Хуулийн 7.1.2, 7.1.3, 7.1.4, 7.1.5, 7.1.7" width={120} format="###,###,###,###,##0.00" />
                        <Column dataField="contractssiincome" caption="Хуулийн 7.1.6" width={120} format="###,###,###,###,##0.00" />
                        <Column dataField="totalincome" caption="Нийт" width={120} format="###,###,###,###,##0.00" />
                    </Column>
                    <Column caption="ЭМД, НДШ">
                        <Column dataField="ssipercent" caption="Хувь" width={120} format="###,###,###,###,##0.00" />
                        <Column dataField="empssi" caption="Дүн(Хуулийн 7,1,1-5, 7,1,7)" width={120} format="###,###,###,###,##0.00" />
                        <Column dataField="contractempssi" caption="Дүн(Хуулийн 7.1.6)" width={120} format="###,###,###,###,##0.00" />
                    </Column>
                    <Column name="tax71income" caption="Хуулийн 7.1-д заасан орлогод татвар ногдуулах орлого" width={120} format="###,###,###,###,##0.00" calculateCellValue={(rowData) => { return rowData?.totalincome - rowData?.empssi - rowData?.contractempssi }} />
                    <Column caption="Албан татвар ногдох шууд бус орлого">
                        <Column dataField="nondirectincometype" caption="Орлогын төрөл" width={120} >
                            <Lookup dataSource={nondirecttypes} valueExpr="key" displayExpr="text" wordWrapEnabled={true} wrapItemText={true} />
                        </Column>
                        <Column dataField="nondirectincome" caption="Орлого" width={120} format="###,###,###,###,##0.00" />
                    </Column>
                    <Column dataField="taxincome" caption="Нийт татвар ногдуулах орлого" width={120} format="###,###,###,###,##0.00" />
                    <Column caption="Шатлал /120.0сая₮ хүртэлх - 1, 120.0-180.0сая₮ - 2, 180.0сая₮-с дээш - 3/" width={120} format="###,###,###,###,##0.00" calculateCellValue={(rowData) => { return rowData.taxincome <= 120000000 ? 1 : rowData.taxincome <= 180000000 ? 2 : 3 }} />
                    <Column caption="Хуулийн 7.1.1, 7.1.5, 7.1.7-д заасан орлогод" >
                        <Column dataField="tax71" caption="Ногдуулсан татвар" width={120} format="###,###,###,###,##0.00" calculateCellValue={(rowData) => { return calcTax71(rowData.ssiincome + rowData.additional, rowData.empssi, rowData.taxincome, rowData.emptax) }} />
                        <Column caption="Хуулийн 23.1-т заасан хөнгөлөлт" >
                            <Column dataField="months" caption="Орлого хүлээн авсан сарын тоо" width={120} format="###,###,###,###,##0.00" />
                            <Column caption="Сард ногдох" width={120} format="###,###,###,###,##0.00" calculateCellValue={(rowData) => { return (rowData.taxdiscount / rowData.months) % 2000 == 0 ? rowData.taxdiscount / rowData.months : 999 }} />
                            <Column dataField="taxdiscount" caption="Нийт" width={120} format="###,###,###,###,##0.00" />
                        </Column>
                    </Column>
                    <Column name="totaltax71" caption="Хуулийн 7.1-д заасан орлогод ногдуулсан хөнгөлөлтийн дараах татвар" width={120} format="###,###,###,###,##0.00" calculateCellValue={(rowData) => { return calcTax71AfterDiscount(rowData.ssiincome + rowData.additional, rowData.empssi, rowData.taxincome, rowData.emptax, rowData?.taxdiscount) }} />
                    <Column name="totaltax716" caption="Хуулийн 7.1.6-д заасан орлогод ногдуулсан татвар" width={120} format="###,###,###,###,##0.00" calculateCellValue={(rowData) => { return calcTax716(rowData.contractssiincome, rowData.contractempssi, rowData.taxincome, rowData.emptax) }} />
                    <Column name="totaltaxnondirect" caption="Шууд бус орлогод ногдуулсан албан татвар" width={120} format="###,###,###,###,##0.00" calculateCellValue={(rowData) => { return calcTaxNonDirect(rowData.ssiincome + rowData.additional, rowData.empssi, rowData.contractssiincome, rowData.contractempssi, rowData.taxincome, rowData.emptax) }} />
                    <Column dataField="emptax" caption="Нийт суутгуулсан албан татварын дүн" width={120} format="###,###,###,###,##0.00" />

                    <Summary>
                        <TotalItem
                            column="ssiincome"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="additional"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="contractssiincome"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="totalincome"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />

                        <TotalItem
                            column="empssi"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="contractempssi"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="tax71income"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="nondirectincome"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="taxincome"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="tax71"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="months"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="taxdiscount"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="totaltax71"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="totaltax716"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="totaltaxnondirect"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                        <TotalItem
                            column="emptax"
                            summaryType="sum"
                            displayFormat="{0}"
                            valueFormat="###,###,###,###,##0.00"
                        />
                    </Summary>
                </DataGrid>
            </div>
        </div>
    );
}



export default TT11Sheet1;